/* Interaktion; Designwerte stehen in der gleichnamigen CSS-Datei. */
(() => {
    if (window.alleycatFilterBarAnimationReady) return;
    window.alleycatFilterBarAnimationReady = true;

    const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    const closeDropdown = (details, returnFocus = false) => {
      if (!details || !details.open) return;

      const filterBar = details.closest('[data-alleycat-filter-bar]');
      const duration = Number.parseInt(filterBar?.dataset.animationDuration, 10) || 220;
      const summary = details.querySelector('.alleycat-filter-bar__summary');

      details.classList.remove('is-open');
      details.classList.add('is-closing');
      window.clearTimeout(details.alleycatCloseTimer);
      window.clearTimeout(details.alleycatHoverCloseTimer);

      details.alleycatCloseTimer = window.setTimeout(() => {
        if (!details.classList.contains('is-open')) details.open = false;
        details.classList.remove('is-closing');
        if (returnFocus) summary?.focus();
      }, duration + 40);
    };

    const openDropdown = (details) => {
      const filterBar = details.closest('[data-alleycat-filter-bar]');

      filterBar?.querySelectorAll('.alleycat-filter-bar__details[open]').forEach((otherDetails) => {
        if (otherDetails !== details) closeDropdown(otherDetails);
      });

      window.clearTimeout(details.alleycatCloseTimer);
      window.clearTimeout(details.alleycatHoverCloseTimer);
      details.classList.remove('is-closing');
      details.open = true;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => details.classList.add('is-open'));
      });
    };

    // Am Computer öffnet sich das Dropdown bereits beim Darüberfahren.
    // Die kurze Schließverzögerung verhindert ein versehentliches Zuklappen
    // auf dem Weg vom Button zu den Filteroptionen.
    document.addEventListener('pointerover', (event) => {
      if (!hoverPointer.matches) return;

      const details = event.target.closest('.alleycat-filter-bar__details');
      if (!details || details.contains(event.relatedTarget)) return;

      window.clearTimeout(details.alleycatHoverCloseTimer);
      openDropdown(details);
    });

    document.addEventListener('pointerout', (event) => {
      if (!hoverPointer.matches) return;

      const details = event.target.closest('.alleycat-filter-bar__details');
      if (!details || details.contains(event.relatedTarget)) return;

      const filterBar = details.closest('[data-alleycat-filter-bar]');
      const delay = Number.parseInt(filterBar?.dataset.hoverCloseDelay, 10) || 160;

      window.clearTimeout(details.alleycatHoverCloseTimer);
      details.alleycatHoverCloseTimer = window.setTimeout(() => {
        if (!details.matches(':hover')) closeDropdown(details);
      }, delay);
    });

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.alleycat-filter-bar__summary');

      if (summary) {
        event.preventDefault();
        const details = summary.closest('.alleycat-filter-bar__details');

        // Ein Mausklick soll ein bereits durch Hover geöffnetes Menü nicht
        // wieder schließen. Tastatur und Touch dürfen weiterhin umschalten.
        if (hoverPointer.matches && event.detail > 0) {
          openDropdown(details);
          return;
        }

        if (details.open && details.classList.contains('is-open')) {
          closeDropdown(details);
        } else {
          openDropdown(details);
        }
        return;
      }

      document.querySelectorAll('.alleycat-filter-bar__details.is-open').forEach((details) => {
        if (!details.contains(event.target)) closeDropdown(details);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.alleycat-filter-bar__details.is-open').forEach((details) => {
        closeDropdown(details, true);
      });
    });
  })();
